// IMPORTANT: Set __webpack_nonce__ BEFORE any style imports
// This tells webpack's style-loader to add the nonce to all injected style tags
import React from 'react';
import ReactDOM from 'react-dom';
import { getCspNonce } from './utils/getCspNonce';
import { setupJssNonce } from './utils/setupJssNonce';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Get nonce and set it for webpack style-loader
// This must be done before any CSS/SCSS imports are processed
const nonce = getCspNonce();
if (nonce) {
  // Set __webpack_nonce__ as a global variable for webpack's style-loader
  // webpack's style-loader automatically checks for this variable
  if (typeof window !== 'undefined') {
    window.__webpack_nonce__ = nonce;
    // eslint-disable-next-line no-undef
    if (typeof __webpack_nonce__ !== 'undefined') {
      // eslint-disable-next-line no-undef
      __webpack_nonce__ = nonce;
    }
    // Also set on globalThis if available (for Node.js environments)
    // eslint-disable-next-line no-undef
    if (typeof globalThis !== 'undefined') {
      // eslint-disable-next-line no-undef
      globalThis.__webpack_nonce__ = nonce;
    }
  }
}

// Setup nonce for JSS and other style injections
// Note: webpack style-loader nonce is set above via __webpack_nonce__
if (nonce) {
  // Setup patching immediately
  setupJssNonce(nonce);
  
  // Aggressive patching - check and patch every 5ms for the first second
  // This catches webpack style-loader which injects during module loading
  let checkCount = 0;
  const aggressiveCheck = setInterval(() => {
    const styleTags = document.querySelectorAll('style');
    let patched = 0;
    styleTags.forEach(style => {
      if (!style.getAttribute('nonce')) {
        style.setAttribute('nonce', nonce);
        try {
          Object.defineProperty(style, 'nonce', {
            value: nonce,
            writable: true,
            configurable: true,
          });
        } catch(e) {}
        patched++;
      }
    });
    checkCount++;
    if (checkCount >= 200) { // Stop after 1 second (200 * 5ms)
      clearInterval(aggressiveCheck);
    }
  }, 5);
  
  // Also verify after a short delay
  setTimeout(() => {
    const styleTags = document.querySelectorAll('style');
    const tagsWithoutNonce = Array.from(styleTags).filter(s => !s.getAttribute('nonce'));
    if (tagsWithoutNonce.length > 0) {
      tagsWithoutNonce.forEach(style => {
        style.setAttribute('nonce', nonce);
      });
    }
  }, 100);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
